import styled from "styled-components";

const Styles = styled.div`
  .tariff_card {
    width: 100%;
    height: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-direction: column;
    border-radius: var(--border-radius);
    background: var(--third-color-blue);
    text-align: center;
    position: relative;
    * {
      margin: 10px 0;
    }
    label {
        margin: 0;
      color: var(--txt-color);
      span {
        font-size: 22px;
        margin: 0;
        input, svg, span {
            margin: 0;
        }
      }
    }
    h4 {
      margin: 0;
      text-align: left;
    }
    .status-card__info {
      width: 100%;
      padding: 0;
      word-wrap: break-word;
    }
  }
  .round {
    width: 130px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 20px auto;
    border-radius: 50%;
    border: 1px solid var(--second-color);
    h3 {
      margin-bottom: 0;
    }
  }
  .menu-dots {
    position: absolute;
    top: -4%;
    right: 5%;
  }
`;
export default Styles;
